<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    width="7.5rem"
    (onHide)="close()">
    <n-header>
        <h1>{{ title }}</h1>
        <n-help-link key="qoutaCreate"></n-help-link>
    </n-header>

    <n-tab (onChange)="onTabChange($event.index)"
        [(activeItem)]="belongType">
        <!-- unix -->
        <n-tab-item [header]="i18n.unixUserLab">
            <ng-template nTemplate>
                <form
                    [formGroup]="unixVm"
                    [errorMessage]="unixErrorMessage">
                    <!-- 用户类型 -->
                    <n-form-item
                        [label]="domainTypeLab"
                        [required]="true">
                        <n-select
                            id="add-user-or-group-type-unix"
                            [options]="unixDomainTypeOpts"
                            (onChange)="domainTypeChange($event.value)"
                            formControlName="domainType">
                        </n-select>
                        <n-tip type="info"
                            style="margin-top: 0.1rem;"
                            [class.hidden]="!showGuideTip || unixVm.value.domainType === DomainTypeE.Local">
                            <app-file-system-guide *ngIf="configGuide"
                                #unixGuide
                                [vstoreId]="vstoreId"
                                [textConfigs]="configGuide.textConfigs"
                                [guideItems]="configGuide.guideItems"
                                (onEnd)="showGuideTip=$event">
                            </app-file-system-guide>
                        </n-tip>
                    </n-form-item>
                    <!-- 本地用户、用户组 -->
                    <n-form-item
                        *ngIf="unixDomainType === DomainTypeE.Local"
                        [labelHide]="true">
                        <n-tip
                            *ngIf="unixShowErrorMsg"
                            [type]="'failed'"
                            [content]="i18n.atLeastSelectOneTip">
                        </n-tip>
                        <n-transfer-table
                            id="add-user-table-unix"
                            [config]="unixTableConfig"
                            [leftColumnDefs]="unixTableColumns"
                            [rest]="unixRest"
                            [(selection)]="unixSelection"
                            (selectionChange)="onSelectionChange()">
                        </n-transfer-table>
                    </n-form-item>
                    <!-- LDAP NIS 用户、用户组 -->
                    <n-form-item
                        *ngIf="unixDomainType !== DomainTypeE.Local"
                        [label]="i18n.nameLab"
                        [required]="true">
                        <n-multi-input
                            id="add-user-input-name-unix"
                            [escape]="true"
                            formControlName="names"
                            [nTooltip]="i18n.escapeMultiNameTip"
                            [nTooltipTrigger]="'focus'"
                            [nTooltipPlacement]="'left'">
                        </n-multi-input>
                    </n-form-item>
                </form>
            </ng-template>
        </n-tab-item>

        <!-- windows -->
        <!--  配额类型为用户、选择用户组时不展示-->
        <n-tab-item
            *ngIf="(quotaType !== FsQuotaTypeE.USER || type !== FsQuotaNameTypeE.GROUP) && !ProductConfig.isHideWindowsUserQuota"
            [header]="i18n.windowsUserLab">
            <ng-template nTemplate>
                <form
                    [formGroup]="windowsVm"
                    [errorMessage]="windowsErrorMessage">
                    <!-- 用户类型 -->
                    <n-form-item
                        [label]="domainTypeLab"
                        [required]="type === FsQuotaNameTypeE.USER">
                        <div *ngIf="type === FsQuotaNameTypeE.GROUP"
                            class="add-user-or-group-type-span">
                            <span>{{i18n.adUserGrouplabel}}</span>
                        </div>
                        <n-select *ngIf="type === FsQuotaNameTypeE.USER"
                            formControlName="domainType"
                            (onChange)="domainTypeChange($event.value)"
                            id="add-user-or-group-type-windows"
                            [options]="windowsDomainTypeOpts">
                        </n-select>
                        <n-tip type="info"
                            style="margin-top: 0.1rem;"
                            [class.hidden]="!showGuideTip || windowsVm.value.domainType === DomainTypeE.Local">
                            <app-file-system-guide *ngIf="configGuide"
                                #windowsGuide
                                [vstoreId]="vstoreId"
                                [textConfigs]="configGuide.textConfigs"
                                [guideItems]="configGuide.guideItems"
                                (onEnd)="showGuideTip=$event">
                            </app-file-system-guide>
                        </n-tip>
                    </n-form-item>
                    <!-- 本地用户、用户组 -->
                    <n-form-item
                        *ngIf="windowsDomainType === DomainTypeE.Local"
                        [labelHide]="true">
                        <n-tip
                            *ngIf="WindowsShowErrorMsg"
                            [type]="'failed'"
                            [content]="i18n.atLeastSelectOneTip">
                        </n-tip>
                        <n-transfer-table
                            id="add-user-table-windows"
                            [config]="windowsTableConfig"
                            [leftColumnDefs]="windowsTableColumns"
                            [rest]="windowsRest"
                            [(selection)]="windowsSelection"
                            (selectionChange)="onSelectionChange()">
                        </n-transfer-table>
                    </n-form-item>
                    <!-- AD域 -->
                    <n-form-item
                        *ngIf="windowsDomainType === DomainTypeE.AD"
                        [label]="i18n.nameLab"
                        [maxErrorTip]="99"
                        [required]="true">
                        <n-multi-input
                            id="add-ad-user-input-name"
                            formControlName="names"
                            [seperator]="[]"
                            [nTooltip]="type === 'user' ? i18n.adMultiNameTip : i18n.adGroupMultiNameTip"
                            [nTooltipTrigger]="'focus'"
                            [nTooltipPlacement]="'left'">
                        </n-multi-input>
                    </n-form-item>
                </form>
            </ng-template>
        </n-tab-item>
    </n-tab>

    <n-footer>
        <button id="select-user-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="select-user-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>